/* eslint-disable */

// apps/src/fontConstants.js
// GENERATED FILE: DO NOT MODIFY DIRECTLY
// This generated file exports all variables defined in shared/css/font.scss
// for use in JavaScript. The generator script is convert-scss-variables.js
module.exports = {
  "gotham-regular": "'Gotham 4r', sans-serif",
  "gotham-italics": "'Gotham 4i', sans-serif",
  "gotham-bold": "'Gotham 5r', sans-serif",
  "gotham-bold-italics": "'Gotham 5i', sans-serif",
  "gotham-extra-bold": "'Gotham 7r', sans-serif",
  "gotham-extra-bold-italics": "'Gotham 7i'",
  "metropolis-font": "'Metropolis', sans-serif",
  "main-font": "'Metropolis', sans-serif",
  "thin-font-weight": "100",
  "extra-light-font-weight": "200",
  "light-font-weight": "300",
  "regular-font-weight": "400",
  "medium-font-weight": "500",
  "semi-bold-font-weight": "600",
  "bold-font-weight": "700",
  "extra-bold-font-weight": "800",
  "black-font-weight": "900",
  "main-font-thin": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "100",
  "fontStyle": "normal",
  },
  "main-font-thin-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "100",
  "fontStyle": "italic",
  },
  "main-font-extra-light": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "200",
  "fontStyle": "normal",
  },
  "main-font-extra-light-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "200",
  "fontStyle": "italic",
  },
  "main-font-light": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "300",
  "fontStyle": "normal",
  },
  "main-font-light-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "300",
  "fontStyle": "italic",
  },
  "main-font-regular": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "400",
  "fontStyle": "normal",
  },
  "main-font-regular-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "400",
  "fontStyle": "italic",
  },
  "main-font-medium": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "500",
  "fontStyle": "normal",
  },
  "main-font-medium-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "500",
  "fontStyle": "italic",
  },
  "main-font-semi-bold": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "600",
  "fontStyle": "normal",
  },
  "main-font-semi-bold-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "600",
  "fontStyle": "italic",
  },
  "main-font-bold": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "700",
  "fontStyle": "normal",
  },
  "main-font-bold-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "700",
  "fontStyle": "italic",
  },
  "main-font-extra-bold": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "800",
  "fontStyle": "normal",
  },
  "main-font-extra-bold-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "800",
  "fontStyle": "italic",
  },
  "main-font-black": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "900",
  "fontStyle": "normal",
  },
  "main-font-black-italic": {
  "fontFamily": "'Metropolis', sans-serif",
  "fontWeight": "900",
  "fontStyle": "italic",
  },
  "barlowSemiCondensed-semibold": "'Barlow Semi Condensed Semibold', sans-serif",
  "barlowSemiCondensed-medium": "'Barlow Semi Condensed Medium', sans-serif",
  "code-font": "'Source Code Pro', Monaco, 'Bitstream Vera Sans Mono', 'Lucida Console', Terminal, monospace",
  "font-awesome-core-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/fontawesome.min.css'",
  "font-awesome-brands-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/brands.min.css'",
  "font-awesome-solid-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/solid.min.css'",
  "font-awesome-regular-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/regular.min.css'",
  "font-awesome-v4-fonts-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/v4-font-face.min.css'",
  "font-awesome-v4-shims-url": "'https://dsco.code.org/assets/font-awesome-pro/1684178876/css/v4-shims.min.css'",
};
